/**
 * functions
 */
import { updateLazy } from 'Functions/lazy';
import { initTippy } from 'Functions/tippy';
import { initializeScrollIndicator } from 'Functions/scroll-indicator';
import { initCountdowns } from 'Functions/countdown';
import { initCopyTexts } from 'Functions/copy-text';
import { initDatepickers } from 'Functions/datepicker'
import smoothscroll from 'smoothscroll-polyfill';

/**
 * common & components
 */
import 'Common/eshop';
import 'Common/window';
import 'Common/info-messages';
import 'Common/toggle-password';
import 'Common/touch-click';
import 'Common/general';
import 'Common/google-analytics-tracking';
import 'Common/cookiebot';
import 'Common/country-change';

import 'Common/product-cart-quantity';

import 'Components/modal/modal-back';
import 'Components/modal/modal-jump';

import 'Components/header';
import 'Components/footer';

/**
 * script
 */
window.Cart.customCallbacks.addedItem = function (form, response) {
    window.rEvent.dispatch('Custom.Cart.addedItem', { form, response })
}
window.Cart.customCallbacks.updatedItem = function (input, response) {
    window.rEvent.dispatch('Custom.Cart.updatedItem', { input, response })
}
window.Cart.customCallbacks.removedItem = function (form, response) {
    window.rEvent.dispatch('Custom.Cart.removedItem', { form, response })
}

window.updateLazy = updateLazy();

document.addEventListener('DOMContentLoaded', () => {
    updateLazy()
    initTippy()
    initCountdowns()
    initCopyTexts()
    initDatepickers()
});

function checkIcdph() {
    if (document.querySelector('.js-toggle-icdph .c-form__input[type="checkbox"]').checked) {
        document.querySelector('.js-cz-dic .c-form__input').setAttribute('required', 'required');
        document.querySelector('.js-cz-dic').classList.add('is-required');
    } else {
        document.querySelector('.js-cz-dic .c-form__input').removeAttribute('required');
        document.querySelector('.js-cz-dic').classList.remove('is-required');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-back').forEach(back => {
        if (window.history.length <= 1) {
            back.style.display = 'none'
        } else {
            back.addEventListener('click', event => {
                if (event.currentTarget.getAttribute('href') == '#') {
                    event.preventDefault()
                    window.history.back()
                }
            })
        }
    })

    if (document.querySelector('.js-toggle-icdph')) {
        checkIcdph();

        document.querySelector('.js-toggle-icdph .c-form__input[type="checkbox"]').addEventListener('change', event => {
            checkIcdph();
        });
    }
})

initializeScrollIndicator('.js-breadcrumb-scroll-holder', '.js-breadcrumb-scroll-content', true)

smoothscroll.polyfill();
